const errorLogs = (state) => state.errorLogs;
const errorFile = (state) => state.errorFile;
export default {
  errorLogs,
  errorFile,
};
